import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, isNotEmpty } from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class RepresentationDTO {

  @ApiProperty()
  @ApiPropertyOptional()
  Id?: number;
  @ApiProperty()
  @ApiPropertyOptional()
  text:string;
  @ApiProperty()
  firstName:string;
  @ApiProperty()
  @ApiPropertyOptional()
  lastName:string;
  @ApiProperty()
  @ApiPropertyOptional()
  address:string;
  @ApiProperty()
  @ApiPropertyOptional()
  villageId:number;
  @ApiProperty()
  @ApiPropertyOptional()
  @MaxLength(10, { message: "Mobile number allows 10 characters only. " })
  mobileNo:string;
  @ApiProperty()
  @ApiPropertyOptional() 
  email: string;
  @ApiProperty()
  userId:number;
  @ApiProperty({ type: 'array', items: { type: 'string', format: 'binary' } })
  @ApiPropertyOptional()
  attachments?:string;
  @ApiProperty()
  @ApiPropertyOptional()
  status: boolean;
  createdAt : Date;
  @ApiProperty()
  @IsOptional()
  @ApiPropertyOptional()
  createdUser : number;
  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @ApiPropertyOptional()
  updatedUser : number;
  @ApiProperty()
  @ApiPropertyOptional()
  versionFlag : number;
}


export class RepresentStatusUpdateDto {
    @ApiProperty()
    Id: number;
    @ApiProperty()
    status: boolean;
    updatedAt : Date;
    @ApiProperty()
    @IsOptional()
    updatedUser : number;
    @ApiProperty()
    versionFlag : number;
  }
